import { ITask } from '@/interfaces/tasks'
import { mapImageFields } from '@/adapters/common'

export function mapTaskFields(item: Directus.Task): ITask {
  return {
    image: mapImageFields(item.image),
    ...item.translations[0],
  }
}
